import React, { useEffect, useMemo, useState } from "react";

import "../styles/Payments.css";

import PaymentHeader from "../components/payments/PaymentHeader";
import PaymentStats from "../components/payments/PaymentStats";
import PaymentFilterBar from "../components/payments/PaymentFilterBar";
import PaymentTable from "../components/payments/PaymentTable";

import { getPayments } from "../services/adminApi";

const Payments = () => {

    const [payments, setPayments] = useState([]);

    const [loading, setLoading] = useState(true);

    const [filters, setFilters] = useState({

        search: "",

        status: "All",

        method: "All",

        gateway: "All",

    });

    // ===========================
    // Fetch Payments
    // ===========================

    const fetchPayments = async () => {

        try {

            setLoading(true);

            const response = await getPayments();

            setPayments(response.data.payments || []);

        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        fetchPayments();

    }, []);

    // ===========================
    // Filter Payments
    // ===========================

    const filteredPayments = useMemo(() => {

        return payments.filter((payment) => {

            const search = filters.search.toLowerCase();

            const matchesSearch =

                payment.paymentNumber?.toLowerCase().includes(search) ||

                payment.orderNumber?.toLowerCase().includes(search) ||

                payment.customerSnapshot?.name
                    ?.toLowerCase()
                    .includes(search) ||

                payment.providerSnapshot?.businessName
                    ?.toLowerCase()
                    .includes(search);

            const matchesStatus =
                filters.status === "All" ||
                payment.payment?.status === filters.status;

            const matchesMethod =
                filters.method === "All" ||
                payment.payment?.method === filters.method;

            const matchesGateway =
                filters.gateway === "All" ||
                payment.payment?.gateway === filters.gateway;

            return (
                matchesSearch &&
                matchesStatus &&
                matchesMethod &&
                matchesGateway
            );

        });

    }, [payments, filters]);

    // ===========================
    // Statistics
    // ===========================

    const stats = useMemo(() => {

        return {

            total: filteredPayments.length,

            successful: filteredPayments.filter(
                p => p.payment?.status === "Success"
            ).length,

            pending: filteredPayments.filter(
                p => p.payment?.status === "Pending"
            ).length,

            refunded: filteredPayments.filter(
                p => p.payment?.status === "Refunded"
            ).length,

            revenue: filteredPayments.reduce(
                (sum, p) =>
                    p.payment?.status === "Success"
                        ? sum + (p.pricing?.grandTotal || 0)
                        : sum,
                0
            ),

        };

    }, [filteredPayments]);

    return (

        <div className="payments-page">

            <PaymentHeader
                loading={loading}
                onRefresh={fetchPayments}
            />

            <PaymentStats
                stats={stats}
            />

            <PaymentFilterBar
                filters={filters}
                setFilters={setFilters}
            />

            <PaymentTable
                payments={filteredPayments}
            />

        </div>

    );

};

export default Payments;